import React from 'react';
import Hero from '../components/Hero';

import ValueProps from '../components/ValueProps';

const HomePage: React.FC = () => {
  return (
    <>
      <Hero />
      <ValueProps />
    </>
  );
};

export default HomePage;